<template lang="pug">
div
  app-divider(label="Dados do VTN", :showBorder="true")
  div(v-if="isParcelaGeo")
    div(v-for="(parcela, index) in parcelas")
      el-row(:gutter="10")
        el-col(:span="24")
          h4 {{parcela.municipio.nome}}
        el-col.container-input(:md="12", :lg="5")
          validation-provider(rules="required|min_value:0.0001", v-slot="{ errors }", :name="getName(index, 'Área requerida')")
            app-label(:label="'Área requerida (ha):'", :required="true")
            app-double-input(v-model="parcela.areaRequerida", :hasValidationError="errors[0] ? true : false", :precision="4", @change="setarParcelas(index)")
            span.help.erro {{ errors[0] }}
        el-col.container-input(:md="12", :lg="7")
          validation-provider(rules="required", v-slot="{ errors }", :name="getName(index, 'Fator distância')", mode="lazy")
            app-label(label="Fator de distância (IFa):", :required="true")
            el-select.input(
              class="select",
              placeholder="Selecione",
              value-key="id",
              name="Fator distância",
              :class="{'erro' : errors.length}",
              v-model="parcela.fatorDistancia",
              :disabled="vtnExcedente"
              @change="setarParcelas(index)"
              clearable
            )
              el-option(
                v-for="item in fatoresDistancia",
                :key="item.id",
                :label="item.descricao",
                :value="item"
              )
            span.help.erro {{ errors[0] }}
        el-col.container-input(:md="12", :lg="7")
          validation-provider(rules="required", v-slot="{ errors }", :name="getName(index, 'Fator Acesso')", mode="lazy")
            app-label(label="Fator de acesso (IFb):", :required="true")
            el-select.input(
              class="select",
              placeholder="Selecione",
              value-key="id",
              name="Fator acesso",
              :class="{'erro' : errors.length}"
              :disabled="vtnExcedente"
              v-model="parcela.fatorAcesso"
              clearable,
              @change="setarParcelas(index)"
            )
              el-option(
                v-for="item in fatoresAcesso",
                :key="item.id",
                :label="item.descricao",
                :value="item"
              )
            span.help.erro {{ errors[0] }}
        el-col.container-input(:md="12", :lg="5")
          validation-provider(rules="required|notZero", v-slot="{ errors }", :name="getName(index, 'Tempo de ocupação')")
            app-label(label="Tempo de ocupação (ano):", :required="true")
            el-input.input(
              placeholder='0',
              v-model="parcela.tempoDeOcupacao",
              :class="{'erro' : errors.length}",
              :disabled="vtnExcedente"
              v-mask="['###']",
              @change="setarParcelas(index)"
            )
            span.help.erro {{ errors[0] }}
  el-row(:gutter="10", v-else)
    el-col.container-input(:md="12", :lg="5")
      validation-provider(rules="required|min_value:0.0001", v-slot="{ errors }", name="Área requerida")
        app-label(:label="vtnExcedente ? 'Área requerida excedente (ha):' : 'Área requerida (ha):'", :required="true")
        app-double-input(
          v-model="areaRequerida",
          :hasValidationError="errors[0] ? true : false",
          :precision="4",
        )
        span.help.erro {{ errors[0] }}
    el-col.container-input(:md="12", :lg="7")
      validation-provider(rules="required", v-slot="{ errors }", name="Fator distância", mode="lazy")
        app-label(label="Fator de distância (IFa):", :required="true")
        el-select.input(
          class="select",
          placeholder="Selecione",
          value-key="id",
          name="Fator distância",
          :class="{'erro' : errors.length}"
          :disabled="vtnExcedente"
          v-model="fatorDistancia"
          clearable
        )
          el-option(
            v-for="item in fatoresDistancia",
            :key="item.id",
            :label="item.descricao",
            :value="item"
          )
        span.help.erro {{ errors[0] }}
    el-col.container-input(:md="12", :lg="7")
      validation-provider(rules="required", v-slot="{ errors }", name="Fator Acesso", mode="lazy")
        app-label(label="Fator de acesso (IFb):", :required="true")
        el-select.input(
          class="select",
          placeholder="Selecione",
          value-key="id",
          name="Fator acesso",
          :class="{'erro' : errors.length}"
          :disabled="vtnExcedente"
          v-model="fatorAcesso"
          clearable
        )
          el-option(
            v-for="item in fatoresAcesso",
            :key="item.id",
            :label="item.descricao",
            :value="item"
          )
        span.help.erro {{ errors[0] }}
    el-col.container-input(:md="12", :lg="5")
      validation-provider(rules="required|notZero", v-slot="{ errors }", name="Tempo de ocupação")
        app-label(label="Tempo de ocupação (ano):", :required="true")
        el-input.input(
          v-model="tempoOcupacao",
          :class="{'erro' : errors.length}",
          :disabled="vtnExcedente"
          v-mask="['###']"
        )
        span.help.erro {{ errors[0] }}
  el-row(v-if="tipoProcesso === 'ONEROSO' && !vtnExcedente")
    .container-input.termo
      el-checkbox.check(v-model="respeitaLegislacaoAmbiental")
        span.checkbox-label(v-html="labelRespeita")

    .container-input.termo
      el-checkbox.check(v-model="temDireitoRegularizacao")
        span.checkbox-label(v-html="labelTemDireito")
</template>

<script>
import AppDivider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
import AppDoubleInput from '@/components/AppDoubleInput'
import _ from 'lodash'
import { mapActions } from 'vuex'

export default {

  components: {
    AppDivider,
    AppLabel,
    AppDoubleInput
  },

  props: {
    modulo: {
      type: String,
      default: 'vtn'
    },
    tipoProcesso: {
      type: String,
      required: true
    },
    vtnExcedente: {
      type: Boolean,
      default: false
    },
    valorExcedente: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      labelRespeita: `Respeita a legislação ambiental, preservando originariamente a reserva legal nos índices legalmente previstos e conservando a área de preservação permanente, com a devida apresentação pelo interessado da comprovação emitida pelo órgão ambiental (desconto de 20%)`,
      labelTemDireito: `Tem direito a regularização fundiária através do regime especial de compra (desconto de 30%)`,
      parcelas: null,
      load: false
    }
  },

  methods: {
    ...mapActions({
      setConstants: 'vtn/setConstants'
    }),
    setarParcelas (index) {
      this.$store.commit(`${this.modulo}/SET_PARCELAS_INDEX`, {index: index, dados: this.parcelas[index]})
    },
    getName (index, field) {
      return `${field}  ${index}`
    }
  },

  async created () {
    await this.setConstants()
  },

  computed: {
    isParcelaGeo () {
      return this.$store.getters[`${this.modulo}/dadosVtn`]?.calculosVtn?.dadosParcelaGeoVtn?.length > 0
    },
    fatoresAcesso () {
      return this.$store.getters[`${this.modulo}/fatoresAcesso`]
    },

    fatoresDistancia () {
      return this.$store.getters[`${this.modulo}/fatoresDistancia`]
    },

    areaRequerida: {
      get () {
        return this.$store.getters[`${this.modulo}/dadosVtn`].areaRequerida
      },
      set (value) {
        this.$store.commit(`${this.modulo}/SET_FIELD_VALUE`, { field: 'areaRequerida', value })
      }
    },

    fatorDistancia: {
      get () {
        return this.$store.getters[`${this.modulo}/dadosVtn`].fatorDistancia
      },
      set (value) {
        this.$store.commit(`${this.modulo}/SET_FIELD_VALUE`, { field: 'fatorDistancia', value })
      }
    },

    fatorAcesso: {
      get () {
        return this.$store.getters[`${this.modulo}/dadosVtn`].fatorAcesso
      },
      set (value) {
        this.$store.commit(`${this.modulo}/SET_FIELD_VALUE`, { field: 'fatorAcesso', value })
      }
    },

    tempoOcupacao: {
      get () {
        return this.$store.getters[`${this.modulo}/dadosVtn`].tempoOcupacao === 0 ? null : this.$store.getters[`${this.modulo}/dadosVtn`].tempoOcupacao
      },
      set (value) {
        this.$store.commit(`${this.modulo}/SET_FIELD_VALUE`, { field: 'tempoOcupacao', value })
      }
    },

    respeitaLegislacaoAmbiental: {
      get () {
        return this.$store.getters[`${this.modulo}/dadosVtn`].respeitaLegislacaoAmbiental
      },
      set (value) {
        this.$store.commit(`${this.modulo}/SET_FIELD_VALUE`, { field: 'respeitaLegislacaoAmbiental', value })
      }
    },

    temDireitoRegularizacao: {
      get () {
        return this.$store.getters[`${this.modulo}/dadosVtn`].temDireitoRegularizacao
      },
      set (value) {
        this.$store.commit(`${this.modulo}/SET_FIELD_VALUE`, { field: 'temDireitoRegularizacao', value })
      }
    }

  },
  watch: {
    isParcelaGeo: function (newQuestion, oldQuestion) {
      this.parcelas = _.cloneDeep(this.$store.getters[`${this.modulo}/dadosVtn`]?.calculosVtn?.dadosParcelaGeoVtn)
      this.parcelas.forEach(parcela => {
        parcela.tempoDeOcupacao = parcela.tempoDeOcupacao === 0 ? null : parcela.tempoDeOcupacao
      })
    }
  },
  async mounted () {
    this.parcelas = _.cloneDeep(this.$store.getters[`${this.modulo}/dadosVtn`]?.calculosVtn?.dadosParcelaGeoVtn)
  }
}
</script>
<style lang="scss" scoped>
.check {
  margin-right: 2%;
  display: flex;
  align-items: center;
  white-space: normal;
}

.termo {
  display: flex;
  align-items: center;
}

.el-select {
  width: 100%;
}

.checkbox-label {
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/screens/financeiro/vtn/DadosVtn.vue